import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { tr } from 'i18n';


import soundoff from "assets/side_pane_new_icons/volumemute.svg";
import soundon from "assets/side_pane_new_icons/volume.svg";
import reload from "assets/side_pane_new_icons/refresh.png";

import Badge from '@mui/material/Badge'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import onoxologo from 'assets/img/fav.png'



import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import PersonalMenuCard from 'pages/ProfilePage/PersonalMenu/PersonalMenuCard'
import { useEffect, useState } from 'react'
import Moment from 'react-moment'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { changeThemeAction } from 'store/slices/UserSlice'
import UserAvatar from 'components/Erp/UserAvatar'

import userInfo from 'utils/userInfo'

import sun from "assets/icons/sun.png";
import MenuDrawerMobile from '../Sidebar/components/Menu/MenuDrawerMobile'
import stylesB from './Header.module.scss'
import stylesW from './HeaderW.module.scss'
import { getImage } from "service/BackgroundService";






function Header({ width, setBackgroundImage }) {
  useInterfaceLanguage();

  const currentUser = useSelector(state => state.user)
  const navigate = useNavigate()
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  })
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const initialMuteStatus = localStorage.getItem('mute') === 'true'
  const [muteStatus, setMuteStatus] = useState(initialMuteStatus)

  const handleSwitchMute = () => {
    const newMuteStatus = !muteStatus
    setMuteStatus(newMuteStatus)
    localStorage.setItem('mute', newMuteStatus.toString())
  }

  const user = userInfo()
  useEffect(() => {
    if (!currentUser.userId) {
      navigate("/"); // перекидывает на главную
    }
  }, [currentUser.userId, navigate]);

  const [styles, setThem] = useState(stylesB)


  let data;
  const dispatch = useDispatch()
  const [text, setText] = useState(false)

  useEffect(() => {

    if (user?.them) {
      setThem(stylesW)
    }
    else {
      setThem(stylesB)
    }
  }, []);








  const navItemCount =
    1 +
    (user?.is_admin_of ? 2 : 0) +
    (user?.is_report_of ? 1 : 0)

  return (
    <>
      <div className={styles.header__wrapper}>
        {width >= 769 ? (
          <div onClick={() => navigate('/home/')} className={styles.logo__wrapper}><img className={styles.img} src={onoxologo} /></div>
        ) : (
          <>
            {tr(navItemCount > 1 && <MenuDrawerMobile />)}
            <div onClick={() => navigate('/home/')} className={styles.logo__wrapper} style={{ flexGrow: 1 }}>
              <img src={onoxologo} style={{ width: 36, height: 36, objectFit: 'contain' }} />
            </div>
          </>
        )}

        <p className={styles.date_interval}>
          <Moment format="HH:mm:ss" interval={1000} />
        </p>




        <IconButton >
          {muteStatus ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', cursor: "pointer" }}
              onClick={handleSwitchMute}
            >
              <img src={soundoff} alt="" onClick={handleSwitchMute} className={styles.imgchat} />
            </div>

          ) : (
            <div style={{ display: "flex", alignItems: "center", justifyContent: 'center', cursor: "pointer" }}
              onClick={handleSwitchMute}
            >
              <img src={soundon} alt="" onClick={handleSwitchMute} className={styles.imgchat} />
            </div>
          )}
        </IconButton>







        {user?.them ?

          ""
          : <div style={{ display: "flex", alignItems: "center", padding: '4px', justifyContent: 'center', cursor: "pointer" }}

          >
            <img src={sun} alt="" className={styles.imgchat} />
          </div>}
        <PopupState variant="popover" popupId="demo-popup-popover">
          {(popupState) => (
            <>
              <div className={styles.user__wrapper}>
                <div className={styles.avatar2} {...bindTrigger(popupState)}>
                  <UserAvatar user={currentUser} className={styles.image__cover} />
                </div>
              </div>

              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              >
                {/* <ProfilePage /> */}
                <PersonalMenuCard setBackground={setBackgroundImage} />
              </Popover>
            </>
          )}
        </PopupState>
      </div>


    </>
  )
}

export default Header
